import Splide from '@splidejs/splide';
import { tabstoriesInit } from './tab-stories';
import { initSearch } from './search';
import './nav.ts';
import './audio.ts';
import './thief-banner-color.ts';
import './fullwidth-video.ts';

// Enhanced GSAP Animation Setup for Multiple Dropdowns
document.addEventListener('DOMContentLoaded', function () {
  const splideElems = document.querySelectorAll('.splide');
  let splides: { [x: string]: Splide } = {};
  splideElems.forEach((splideElem) => {
    const splide = new Splide(splideElem as HTMLElement);
    splides[splideElem.id] = splide;
    splide.mount();
  });

  tabstoriesInit(splides);
  initSearch();
});
